import React, { useState } from 'react';
import { Check, ShieldCheck, Lock, Mail } from 'lucide-react';
import { Button } from './ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '../lib/utils';
const COMBOS = [{
  id: 'combo2',
  title: 'COMBO 2: EL MÁS ELEGIDO',
  subtitle: 'El equilibrio perfecto entre producción y optimización.',
  price: '29.990',
  originalPrice: '59.990',
  discount: '50%',
  url: 'https://checkout5.rosetadigital.com/cart/48829788389600:1',
  isRecommended: true,
  features: [{
    text: 'Manual Principal Huerta 360º (PDF digital)',
    highlight: false
  }, {
    text: 'Manual 2: Huerta Intensiva y Optimización',
    highlight: true
  }, {
    text: 'Bonus: Calendario Productivo Anual',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Fertilizantes Naturales',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Mini Invernadero Low Cost',
    highlight: false,
    isBonus: true
  }, {
    text: 'Material digital (PDF) — enviado por mail',
    highlight: false,
    isFile: true
  }]
}, {
  id: 'combo1',
  title: 'COMBO 1: COMPLETO PARA EMPEZAR',
  subtitle: 'Para iniciar tu huerta desde cero y sin errores.',
  price: '19.990',
  originalPrice: '39.990',
  discount: '50%',
  url: 'https://checkout5.rosetadigital.com/cart/48829786587360:1',
  isRecommended: false,
  features: [{
    text: 'Manual Principal Huerta 360º (PDF digital)',
    highlight: false
  }, {
    text: 'Bonus: Calendario Productivo Anual',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Fertilizantes Naturales',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Mini Invernadero Low Cost',
    highlight: false,
    isBonus: true
  }, {
    text: 'Material digital (PDF) — enviado por mail',
    highlight: false,
    isFile: true
  }]
}, {
  id: 'combo3',
  title: 'COMBO 3: NIVEL EMPRENDEDOR',
  subtitle: 'Dominio total para producir y monetizar tu huerta.',
  price: '39.990',
  originalPrice: '79.990',
  discount: '50%',
  url: 'https://checkout5.rosetadigital.com/cart/48829795598560:1',
  isRecommended: false,
  features: [{
    text: 'Manual Principal Huerta 360º (PDF digital)',
    highlight: false
  }, {
    text: 'Manual 2: Huerta Intensiva y Optimización',
    highlight: true
  }, {
    text: 'Manual 3: Huerta como Emprendimiento',
    highlight: true
  }, {
    text: 'Bonus: Calendario Productivo Anual',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Fertilizantes Naturales',
    highlight: false,
    isBonus: true
  }, {
    text: 'Bonus: Mini Invernadero Low Cost',
    highlight: false,
    isBonus: true
  }, {
    text: 'Material digital (PDF) — enviado por mail',
    highlight: false,
    isFile: true
  }]
}];
export function CheckoutSection() {
  const [selectedComboId, setSelectedComboId] = useState('combo2');
  const selectedCombo = COMBOS.find(c => c.id === selectedComboId) || COMBOS[1];
  const handleBuy = () => {
    console.log(`Buying ${selectedCombo.id}`);
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: selectedCombo.id,
        currency: 'ARS',
        value: parseInt(selectedCombo.price.replace('.', ''))
      });
    }
    window.location.href = selectedCombo.url;
  };
  const mercadoPagoBadge = <div className="flex items-center justify-center gap-2 py-2" data-id="element-38">
      <Lock className="w-3 h-3 text-zinc-400" data-id="element-39" />
      <span className="text-zinc-400 text-[11px] font-medium" data-id="element-40">
        Pago seguro a través de
      </span>
      <img src="https://cdn.magicpatterns.com/uploads/cdqsmWKsK2Wp1dH45Z13Rh/pasted-image.png" alt="Mercado Pago" width={100} height={20} className="h-5 w-[100px] object-contain bg-white rounded px-1" data-id="element-41" />
    </div>;
  return <section id="checkout" className="py-16 px-4 bg-zinc-950" data-id="element-42">
      <div className="max-w-2xl mx-auto" data-id="element-43">
        <div className="text-center mb-8" data-id="element-44">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-45">
            Elegí Tu Combo y Empezá Hoy
          </h2>
          <p className="text-red-500 font-bold text-sm animate-pulse" data-id="element-46">
            ⚠ Oferta con bonos por tiempo limitado
          </p>
        </div>

        {mercadoPagoBadge}

        <div className="bg-[#111111] border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-47">
          {/* Combo List */}
          <div className="flex flex-col" data-id="element-48">
            {COMBOS.map((combo, index) => {
            const isSelected = selectedComboId === combo.id;
            return <div key={combo.id} className="flex flex-col" data-id="element-49">
                  {/* Row Header */}
                  <div onClick={() => setSelectedComboId(combo.id)} className={cn('relative flex items-center justify-between px-5 py-4 cursor-pointer transition-colors', isSelected ? 'bg-[#1a1a1a]' : 'hover:bg-[#161616]', combo.isRecommended && isSelected ? 'border-l-4 border-l-green-500' : 'border-l-4 border-l-transparent')} data-id="element-50">
                    <div className="flex items-center gap-3" data-id="element-51">
                      {/* Radio Button */}
                      <div className="flex-shrink-0" data-id="element-52">
                        <div className={cn('w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors', isSelected ? 'border-green-500' : 'border-zinc-600')} data-id="element-53">
                          {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-green-500" data-id="element-54" />}
                        </div>
                      </div>

                      {/* Title & Subtitle */}
                      <div data-id="element-55">
                        <h3 className="text-white font-black text-sm sm:text-base tracking-wide leading-tight" data-id="element-56">
                          {combo.title}
                        </h3>
                        <p className="text-zinc-500 text-xs mt-0.5" data-id="element-57">
                          {combo.subtitle}
                        </p>
                      </div>
                    </div>

                    {/* Price Area */}
                    <div className="flex flex-col items-end flex-shrink-0 ml-4" data-id="element-58">
                      {combo.isRecommended && <span className="bg-green-500 text-black font-bold text-[9px] uppercase px-2 py-0.5 rounded-sm mb-1" data-id="element-59">
                          MÁS VENDIDO
                        </span>}
                      <div className="flex items-center gap-1.5" data-id="element-60">
                        <span className="text-zinc-500 line-through text-[10px]" data-id="element-61">
                          ${combo.originalPrice}
                        </span>
                        <span className="bg-red-600 text-white text-[9px] font-bold px-1 py-0.5 rounded" data-id="element-62">
                          {combo.discount}
                        </span>
                      </div>
                      <div className="flex items-baseline gap-0.5" data-id="element-63">
                        <span className="text-zinc-400 text-[10px] font-bold" data-id="element-64">
                          ARS
                        </span>
                        <span className="text-2xl sm:text-3xl font-black text-white" data-id="element-65">
                          {combo.price}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Expandable Details */}
                  <AnimatePresence data-id="element-66">
                    {isSelected && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25
                }} className="overflow-hidden bg-[#1a1a1a]" data-id="element-67">
                        <div className="px-5 pb-4 pl-14" data-id="element-68">
                          <p className="text-green-500 font-bold text-[10px] tracking-widest mb-2" data-id="element-69">
                            INCLUYE:
                          </p>
                          <ul className="space-y-1.5" data-id="element-70">
                            {combo.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-xs" data-id="element-71">
                                {feature.isFile ? <Mail className="w-3.5 h-3.5 text-zinc-500 shrink-0 mt-0.5" data-id="element-72" /> : <Check className="w-3.5 h-3.5 text-green-500 shrink-0 mt-0.5" data-id="element-73" />}
                                <span className={cn(feature.highlight ? 'text-yellow-400 font-semibold' : 'text-zinc-300', feature.isFile && 'text-zinc-400')} data-id="element-74">
                                  {feature.text}
                                  {feature.isBonus && <span className="text-green-500 font-bold ml-1" data-id="element-75">
                                      (Gratis)
                                    </span>}
                                </span>
                              </li>)}
                          </ul>
                        </div>
                      </motion.div>}
                  </AnimatePresence>

                  {/* Divider */}
                  {index < COMBOS.length - 1 && <div className="h-px w-full bg-zinc-800" data-id="element-76" />}
                </div>;
          })}
          </div>

          {/* CTA Area */}
          <div className="p-5 bg-[#0a0a0a] border-t border-zinc-800" data-id="element-77">
            <Button size="lg" fullWidth onClick={handleBuy} className="py-5 text-lg" data-id="element-78">
              COMPRAR AHORA
            </Button>

            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[10px] text-zinc-500" data-id="element-79">
              <div className="flex items-center gap-1" data-id="element-80">
                <Lock className="w-3 h-3 text-yellow-500" data-id="element-81" />
                <span data-id="element-82">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-83">
                <Check className="w-3 h-3 text-zinc-400" data-id="element-84" />
                <span data-id="element-85">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-86">
                <Check className="w-3 h-3 text-zinc-400" data-id="element-87" />
                <span data-id="element-88">PDF por email</span>
              </div>
              <div className="flex items-center gap-1" data-id="element-89">
                <ShieldCheck className="w-3 h-3 text-zinc-400" data-id="element-90" />
                <span data-id="element-91">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </div>

        {mercadoPagoBadge}
      </div>
    </section>;
}